import FirestoreService from "../firestore";
import { TransportDistribution } from "@/types/transport-distribution/transport-distribution.types";

interface FirestoreResponse {
  entity?: string;
  [key: string]: any;
}

export const transportDistributionService = {
  create: async (body: Omit<TransportDistribution, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "create-transportDistribution",
      body,
      "setup_transportDistribution",
      issuedBy
    )) as FirestoreResponse;

    const documentId = result?.entity;
    if (!documentId) {
      throw new Error("Failed to create transport distribution: No ID returned");
    }
    return documentId;
  },

  edit: async (id: string, body: Partial<TransportDistribution>, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "edit-transportDistribution",
      { id, ...body },
      "setup_transportDistribution",
      issuedBy
    )) as FirestoreResponse;
    return result;
  },

  archive: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "archive-transportDistribution",
      { documentId },
      "setup_transportDistribution",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },

  restore: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "restore-transportDistribution",
      { documentId },
      "setup_transportDistribution",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },
}; 